export default __webpack_public_path__ + "static/media/code_thinking.45ad7192.svg";